module.exports = __webpack_public_path__ + "img/app_store.cde852ee.png";